<ng-container *transloco="let t">
<div class="flex justify-center items-center text-2xl">
    <img class="dark:hidden w-26 h-26 rounded-full object-contain" src="../../../../../../../assets/images/logo/logo-text.png"
        alt="">
    <img class="hidden dark:inline w-26 h-26 rounded-full object-contain" src="../../../../../../../assets/images/logo/logo-text-dark.png"
        alt="">
</div>

<h1 class="text-2xl text-center -mt-2 mb-1 font-semibold"
    [ngClass]="data.type === 'error' ? 'text-red-500':'text-gradient'">{{data.message}}</h1>



<div class="buttons flex p-4 justify-center items-center mt-4">
    <button type="button" class="bg-primary px-4 py-2 w-32" mat-flat-button [mat-dialog-close]="true">{{ t('Close') }}</button>
</div>
</ng-container>